<template>
<div id="Vue"  style="background:#eceaea;">

 

<el-row style=" padding:20px;margin-top:10px;background: #fff;" justify="start"> 
  <el-row style="padding-bottom:8px"> 数据服务</el-row>
  <el-col :span="6"  @click.native="changeItem('custom')">
    <el-card id="custom" style="background:#F2F6FC"  >
       
      <div style="padding: 2px;">
       
								
								<div class="pay-type">
                                    <span style="text-align:center"><h3>海关数据</h3></span></br>
									<span style="text-align:center" ></span>性价比高的数据服务解决方案<span></span>
                                    
                                </div>
         
      </div>
    </el-card>
  </el-col>
  <el-col :span="6" :offset="1" @click.native="changeItem('linkedIn')">
    <el-card id="linkedIn" style=" background:#F2F6FC">
       
      <div style="padding: 2px;">
	  								
								<div class="pay-type">
                                    <span style="text-align:center"><h3>领英数据 </h3></span></br>
									<span style="text-align:center" ></span> 按次消费，充值更灵活<span></span>
                                    
                                </div>
 
								
							 
   
      </div>
    </el-card>
  </el-col>

  
		
</el-row>

<el-row id="customData" style="  padding:10px; background: #fff;" justify="start" v-show="customShow"  >
  <el-row style="padding-bottom:8px"> 选择类型</el-row>
  <el-col :span="4" @click.native="changeItem('custommonth')" > 
    <el-card id="custommonth" >
       
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>68元/月</h3></span>
        </br>
		<span   style="text-align:center;font-size:12px;color:#909399"> 全球海关数据 ，美国邮箱搜索，广交会采购商信息</span>
      </div>
    </el-card>  
  </el-col> 
  <el-col :span="4" :offset="1" @click.native="changeItem('customyear')"  >
    <el-card id="customyear" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>698元/12个月</h3></span>
        </br>
		<span   style="text-align:center;font-size:12px;color:#909399"> 全球海关数据 ，全球公司数据，广交会数据</span>
 
      </div>
    </el-card>
  </el-col>
 
  
</el-row> 

<el-row id="erpData" style="  padding:10px; background: #fff;" justify="start" v-show="erpShow" >
  <el-row style="padding-bottom:8px"> 选择金额</el-row>
  <el-col :span="4" @click.native="changeItem('in10')" > 
    <el-card id="in10" >
       
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>10元</h3></span>
        </br>
		<span  style="text-align:center;font-size:12px;color:#909399">  </span>
      </div>
    </el-card>  
  </el-col> 
  <el-col :span="4" :offset="1" @click.native="changeItem('in20')"  >
    <el-card id="in20" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>20元</h3></span>
        </br>
		<span  style="text-align:center;font-size:12px;color:#909399">  </span>
      </div>
    </el-card>
  </el-col>
  <el-col :span="4" :offset="1" @click.native="changeItem('in50')"  >
    <el-card id="in50" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>50元</h3></span>
        </br>
		<span  style="text-align:center;font-size:12px;color:#909399">  </span>
      </div>
    </el-card>
  </el-col>
  <el-col :span="4" :offset="1" @click.native="changeItem('in100')"  >
    <el-card id="in100" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>100元</h3></span>
        </br>
		<span  style="text-align:center;font-size:12px;color:#909399">  </span>
      </div>
    </el-card>
  </el-col>
  <el-col :span="4" :offset="1" @click.native="changeItem('in200')"  >
    <el-card id="in200" >
      <div style="padding: 2px;">
        <span  style="text-align:center"><h3>200元</h3></span>
        </br>
		<span  style="text-align:center;font-size:12px;color:#909399">  </span>
      </div>
    </el-card>
  </el-col>
</el-row> 
<el-row id="payment" style=" padding:10px; background: #fff;" justify="start"  >
  <el-row style="padding-bottom:8px"> 支付方式</el-row>
  <el-col :span="2" @click.native="changeItem('paymentAli')" v-show="false" > 
    <div><img  id="paymentAli" src="/static/image/alipay.jpg" alt="103*31"/></div>
  </el-col> 
  <el-col :span="2" :offset="1" @click.native="changeItem('paymentWx')"  >
     <div><img  id="paymentWx" src="/static/image/weixinpay.png" alt="103*31"/></div>
  </el-col>
</el-row> 

  <el-row style=" margin-top:20px; background: #fff;">
              <div style="float:right;margin-top:20px;margin-right:100px">
                <span style="">实付：</span>
				<span id="amount" style="width:200px; padding-bottom:8px; text-align:center;font-size:16px;color:red;">{{amount}} </span><br/><br/>
                <el-button style="margin-bottom:20px;" type="primary" :loading="is_loading" @click="toPay()" >立即支付</el-button>
            </div>
	</el-row>
	
 
	
</div>
</template>
<style>
  .el-col {
    border-radius: 4px;
  }
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
.box{
            position: relative;
            
            overflow: hidden;
           
            margin: 0px;
            border: 3px solid #4390df;
        }
        
        .box:before{
            position: absolute;
            display: block;
            border-top: 28px solid #4390df;
            border-left: 28px solid transparent;
            right: 0;
            top: 0;
            content: "";
            z-index: 101;
        }
        .box:after{
            position: absolute;
            display: block;
            content: "\e013";            
            top: 0;
            right: 0;
            font-family: Glyphicons Halflings;
            font-size: 10pt;
            font-weight: normal;
            z-index: 102;
            color: #fff;
        }
 
</style>

<script>
  export default {
        name: "payment",
        data () {
		  return{
	    	is_loading: false,
		    userInfo: {},
			login_state: 0,
			customShow : true,
			erpShow: false,
			amount: 0, 
			sk_id: 0,
			sk_name: '', 
			pay_mode: 'ali',
			} 
        },
        methods: {
		  toPay(){
		    if (this.pay_mode == 'ali')
			    this.aliPay();
			else
			    this.wxPay();
		  
		  },
		  changeItem(val){ 
              if (val == 'custom'){
			    $("#custom").addClass("box");
				$("#linkedIn").removeClass("box"); 
				this.customShow = true;
				this.erpShow = false; 
				$("#customyear").addClass("box"); 
				
				this.sk_id = 2;
                this.sk_name = '海关数据服务按年';
                this.amount = 698;	
	//		    $("#custom").css("background","#4000df");
	//			$("#erp").css("background","#F2F6FC");
				}
              if (val == 'linkedIn'){
                 $("#custom").removeClass("box");
				 $("#linkedIn").addClass("box");		
                 this.customShow = false;
			  	 this.erpShow = true;
				 $("#in10").addClass("box");
				 $("#in20").removeClass("box"); 
                 $("#in50").removeClass("box");   
				 $("#in100").removeClass("box"); 
				 $("#in200").removeClass("box"); 

				 
			 	 this.sk_id = 10;
                 this.sk_name = '领英数据充值';
                 this.amount = 10;	
              //   $("#customData").css("display","none");				 
		//	    $("#erp").css("background","#4000df");
			//	$("#custom").css("background","#F2F6FC");
				}
              if (val == 'in10'){
				 $("#in10").addClass("box");
				 $("#in20").removeClass("box"); 
                 $("#in50").removeClass("box");   
				 $("#in100").removeClass("box"); 
				 $("#in200").removeClass("box"); 
				 this.sk_id = 10;
                 this.sk_name = '领英数据充值10';
                 this.amount = 10;	
				}
              if (val == 'in20'){
 				 $("#in20").addClass("box");
				 $("#in10").removeClass("box"); 
                 $("#in50").removeClass("box");   
				 $("#in100").removeClass("box"); 
				 $("#in200").removeClass("box"); 
				 this.sk_id = 10;
                 this.sk_name = '领英数据充值20';
                 this.amount = 20;					
				}			
              if (val == 'in50'){
 				 $("#in50").addClass("box");
				 $("#in10").removeClass("box"); 
                 $("#in20").removeClass("box");   
				 $("#in100").removeClass("box"); 
				 $("#in200").removeClass("box"); 
				 this.sk_id = 10;
                 this.sk_name = '领英数据充值50';
                 this.amount = 50;					
				}	
              if (val == 'in100'){
 				 $("#in100").addClass("box");
				 $("#in10").removeClass("box"); 
                 $("#in20").removeClass("box");   
				 $("#in50").removeClass("box"); 
				 $("#in200").removeClass("box"); 
				 this.sk_id = 10;
                 this.sk_name = '领英数据充值100';
                 this.amount = 100;					
				}
              if (val == 'in200'){
 				 $("#in200").addClass("box");
				 $("#in10").removeClass("box"); 
                 $("#in20").removeClass("box");   
				 $("#in50").removeClass("box"); 
				 $("#in100").removeClass("box"); 
				 this.sk_id = 10;
                 this.sk_name = '领英数据充值200';
                 this.amount = 200;					
				}				
              if (val == 'custommonth'){
			    $("#custommonth").addClass("box");
				$("#customyear").removeClass("box");
			    this.sk_id = 1;
                this.sk_name = '海关数据服务按月';
                this.amount = 68;	
				
				}
              if (val == 'customyear'){
                 $("#custommonth").removeClass("box");
				$("#customyear").addClass("box");
				this.sk_id = 2;
                this.sk_name = '海关数据服务按年';
                this.amount = 698;
				
				}	
		
              if (val == 'paymentAli'){
			    $("#paymentAli").addClass("box");
				$("#paymentWx").removeClass("box"); 
				this.pay_mode = 'ali';
				}
              if (val == 'paymentWx'){
                $("#paymentAli").removeClass("box");
				$("#paymentWx").addClass("box");			   
				this.pay_mode = 'wx';
				}		
		  },
		  aliPay(){ 

			 
			  var g_url = 'https://www.myferp.com/admin/user/createOrder';
					let userInfo = localStorage.getItem('userInfo');
					let info1 = JSON.parse(userInfo);
					let id = info1.id;
					this.amount = 0.01;
			  var info = {'user_id':id , 
					'sk_id': this.sk_id,
					'sk_name':  this.sk_name,
					'sk_amount': this.amount,		
					};
			  let that = this;
			  that.is_loading = true;
			  $.ajax({
						 type: "POST",
						 url: g_url,
						 data: info, 
						 dataType: "json",
						 beforeSend: function (request) {
							request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
							},  
						 error: function(XMLHttpRequest, textStatus, errorThrown) {
									alert('请求失败!');
								},
						 success: function(data){
									 console.log(data); 
									 if (data.errno == 0){
									 
										 g_url = '/aliPay'; 
										 let order_sn = data.data.orderInfo.order_sn;
										 let order_name = data.data.orderInfo.sk_name;
										 let order_amount = data.data.orderInfo.sk_amount;
										 localStorage.setItem('orderId', data.data.orderInfo.id );
										 localStorage.setItem('orderAmount', data.data.orderInfo.sk_amount );
										 localStorage.setItem('orderName', data.data.orderInfo.sk_name );
										 $.ajax({
											type: "get",
											url: g_url,
											data: {amount: that.amount, order_sn: order_sn, order_name: order_name, order_amount: order_amount}, 
											dataType: "text",
											error: function(XMLHttpRequest, textStatus, errorThrown) {
														  alert('请求失败!');
														  that.is_loading = false;
													},
											success: function(data){
													console.log(data);
													that.is_loading = false;
													localStorage.setItem('aliPay', data);
													window.location.href= data;
								  
													 }
											});
									 
									 
									 
									 }else{
									   alert(data.errmsg);
									 }
								  }
					 });
			},
		   wxPay(){
			 
			  var g_url = 'https://www.myferp.com/admin/user/createOrder';
					let userInfo = localStorage.getItem('userInfo');
					let info1 = JSON.parse(userInfo);
					let id = info1.id;
			//		this.amount = 0.01;
			  var info = {'user_id':id , 
					'sk_id': this.sk_id,
					'sk_name':  this.sk_name,
					'sk_amount': this.amount,		
					};
			  let that = this;
			  that.is_loading = true;
			  $.ajax({
						 type: "POST",
						 url: g_url,
						 data: info, 
						 dataType: "json",
						 beforeSend: function (request) {
							request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
							},  
						 error: function(XMLHttpRequest, textStatus, errorThrown) {
						         console.log('order fail');
									alert('请求失败!');
								},
						 success: function(data){
									 console.log(data); 
									 if (data.errno == 0){
									 
										 g_url = 'https://www.myferp.com/wxPay'; 
										 let order_sn = data.data.orderInfo.order_sn;
										 let order_name = data.data.orderInfo.sk_name;
										 let order_amount = data.data.orderInfo.sk_amount;
										 localStorage.setItem('orderId', data.data.orderInfo.id );
										 localStorage.setItem('orderAmount', data.data.orderInfo.sk_amount );
										 localStorage.setItem('orderName', data.data.orderInfo.sk_name );
										 $.ajax({
											type: "get",
											url: g_url,
											data: {amount: that.amount, order_sn: order_sn, order_name: order_name, order_amount: order_amount}, 
											dataType: "text",
											error: function(XMLHttpRequest, textStatus, errorThrown) {
														  alert('请求失败!');
														  that.is_loading = false;
													},
											success: function(data){
													console.log('wx response:' + data); // JSON.stringify(data));
													that.is_loading = false;
													localStorage.setItem('wxPay', data) ;// JSON.stringify(data));
													that.$router.push({
					                                    path: '/customs/wxpay',
					                                    params: {
					                                         sometext: ''
					                                         }
				                                        });
								  
													 }
											});
									 
									 
									 
									 }else{
									   alert(data.errmsg);
									 }
								  }
					 });
					 

			},

		},
		mounted(){
		    let userInfo = localStorage.getItem('userInfo'); //判断登录状态
				console.log( 'user:' + typeof userInfo);  
				if (userInfo == '' || userInfo == null  || typeof userInfo == undefined  ) {
				    this.login_state = 0;
					this.$router.push({name:'login'});
				}else{
				    this.login_state = 1;
				}
		  this.changeItem('paymentWx');
		  this.changeItem('custom');
		  this.changeItem('customyear');
		},
		

		}
</script>

 


// WEBPACK FOOTER //
// src/components/customs/payment.vue